import { jsx as _jsx } from "react/jsx-runtime";
import V2Root from "@/v2/V2Root";
export default function V2Proxy() {
    return _jsx(V2Root, {});
}
